export default (API) => ({
	saveDynamicData(data) {
		return API({
			url: '/custom/dynamic/v1/crm/saveClues',
			method: 'post',
			data,
		})
	},
})
